<template>
  <div class="page-wrapper d-flex flex-column min-vh-60">
    <!-- Header -->
    <header
      class="header d-flex align-items-center justify-content-center py-3 shadow-sm bg-light"
    ></header>

    <!-- Content -->
    <main
      style="padding: 20px; background: #efefef !important"
      class="flex-fill d-flex flex-column align-items-center justify-content-start py-5 bg-light"
    >
      <!-- Icon & Title -->
      <div class="text-center mb-4">
        <i class="bi bi-geo-alt-fill fs-1 text-success"></i>
        <h1 class="fw-bold fs-3 mt-3">اختر المنطقة المفضلة</h1>
        <p class="text-muted fs-6">اختر منطقتك لتخصيص العملة وخيارات الدفع</p>
      </div>

      <!-- Loader -->
      <div v-if="isloading" class="loader-container mb-3">
        جاري التحميل
        <div class="spinner-border text-success ms-2" role="status">
          <span class="sr-only"></span>
        </div>
      </div>

      <!-- Regions List -->
      <div v-if="!isloading" class="regions-list">
        <!-- الخيار الدولي -->
        <div
          class="region-card d-flex align-items-center p-3 shadow-sm rounded mb-2"
          @click="selectRegion(null)"
        >
          <i class="fa-solid fa-globe fs-3 text-dark me-3"></i>
          <div class="region-info">
            <h5 class="mb-1">دولي</h5>
            <small> نطاق دولي</small>
          </div>
        </div>

        <!-- باقي المناطق -->
        <div
          v-for="region in regions"
          :key="region.id"
          class="region-card d-flex align-items-center p-3 shadow-sm rounded mb-2"
          @click="selectRegion(region)"
        >
          <img :src="getFlag(region)" class="region-flag me-3" alt="Flag" />
          <div class="region-info">
            <h5 class="mb-1">{{ region.name }}</h5>
            <small>{{ region.currency_ar }} - {{ region.phone_code }}</small>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";
import Swal from "sweetalert2";
import { backupAuthValue, removeFromCookie } from "@/utils/cookieBackup";

const defaultFlags = {
  Libya: "https://flagcdn.com/w80/ly.png",
  Egypt: "https://flagcdn.com/w80/eg.png",
  Tunisia: "https://flagcdn.com/w80/tn.png",
  Algeria: "https://flagcdn.com/w80/dz.png",
  Morocco: "https://flagcdn.com/w80/ma.png",
  SaudiArabia: "https://flagcdn.com/w80/sa.png",
  UAE: "https://flagcdn.com/w80/ae.png",
  USA: "https://flagcdn.com/w80/us.png",
  UK: "https://flagcdn.com/w80/gb.png",
  France: "https://flagcdn.com/w80/fr.png",
  Germany: "https://flagcdn.com/w80/de.png",
  Italy: "https://flagcdn.com/w80/it.png",
  Spain: "https://flagcdn.com/w80/es.png",
  Jordan: "https://flagcdn.com/w80/jo.png",
  Kuwait: "https://flagcdn.com/w80/kw.png",
  Qatar: "https://flagcdn.com/w80/qa.png",
  Bahrain: "https://flagcdn.com/w80/bh.png",
  Oman: "https://flagcdn.com/w80/om.png",
  Lebanon: "https://flagcdn.com/w80/lb.png",
  Iraq: "https://flagcdn.com/w80/iq.png",
};

export default {
  name: "CustomBundleHome",
  data() {
    return {
      regions: [],
      isloading: true,
    };
  },
  mounted() {
    document.getElementById("currentYear").textContent =
      new Date().getFullYear();

    this.fetchRegions();
  },
  methods: {
    async fetchRegions() {
      this.isloading = true;
      try {
        const res = await fetch(`${apiUrl}/home/web`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (res.ok) {
          const data = await res.json();
          this.regions = data.regions || [];
        } else console.error("فشل جلب المناطق");
      } catch (err) {
        console.error("حدث خطأ:", err);
      } finally {
        this.isloading = false;
      }
    },
    getFlag(region) {
      return (
        region.region_flag ||
        defaultFlags[region.name] ||
        "https://via.placeholder.com/40x30"
      );
    },
    async selectRegion(region) {
      // تخزين الريجون (حتى لو null)
      if (region) {
        localStorage.setItem("selectedRegion", JSON.stringify(region));
        backupAuthValue("selectedRegion", JSON.stringify(region));
        window.appRegion = region;
      } else {
        localStorage.removeItem("selectedRegion");
        removeFromCookie("selectedRegion");
        window.appRegion = null;
      }

      Swal.fire({
        title: "جاري معالجة اختيار المنطقة...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      try {
        const headers = {
          "Content-Type": "application/json",
          "x-country-code": region ? region.phone_code : null, // حتى لو null يبعتها
        };

        const res = await fetch(`${apiUrl}/home/web`, {
          method: "GET",
          headers,
        });

        if (res.ok) {
          const data = await res.json();
          if (data.currency) {
            localStorage.setItem("selectedCurrency", data.currency);
            backupAuthValue("selectedCurrency", data.currency);
            window.appCurrency = data.currency;
          }
        } else {
          console.error("فشل جلب بيانات العملة");
        }
      } catch (err) {
        console.error("حدث خطأ أثناء جلب بيانات العملة:", err);
      } finally {
        Swal.close();
        Swal.fire({
          title: "تم التعيين بنجاح",
          text: "سيتم تحويلك الآن",
          icon: "success",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            // التوجيه للصفحة المطلوبة
            window.location.href = "/home"; // غيّرها للمسار اللي تبيه
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  background-color: #f8f9fa;
  font-family: "Cairo", sans-serif;
}

/* Header */
.header .logo {
  height: 50px;
}

/* Loader */
.loader-container {
  font-weight: 700;
  padding: 20px 30px;
  background: rgba(115, 115, 115, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Regions List (عمودي) */
.regions-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 850px;
}

.region-card {
  cursor: pointer;
  background: #fff;
  transition: transform 0.2s, box-shadow 0.2s;
  border-radius: 10px;
}

.region-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.region-flag {
  width: 50px;
  height: 35px;
  object-fit: cover;
  border-radius: 4px;
}

.region-info h5 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.region-info small {
  color: #555;
}
</style>
